import loadable from '@wix/yoshi-flow-editor/loadable';
import type { FC } from 'react';
import React from 'react';

import { PlaceholderLoader } from '../../../../common/components/PlaceholderLoader';
import type { BaseComponentProps, WithLoadableProps } from '../../../../types';
import { ProfileLayout } from '../../../../types';

const RESPONSIVE_WIDGET_HEIGHT = 'var(--profileWidgetHeight)';
const NON_RESPONSIVE_WIDGET_HEIGHT = '214px';

const DesktopResponsiveWidget: FC<WithLoadableProps<BaseComponentProps>> =
  loadable(() => {
    return import(
      /* webpackChunkName: "DesktopResponsiveRootWidget" */ './DesktopResponsiveWidget'
    );
  });

const DesktopNonResponsiveWidget: FC<WithLoadableProps<BaseComponentProps>> =
  loadable(() => {
    return import(
      /* webpackChunkName: "DesktopNonResponsiveRootWidget" */ './DesktopNonResponsiveWidget'
    );
  });

const DesktopWidget: FC<BaseComponentProps> = (props) => {
  const { profileLayout, shouldUsePlaceholderLoaders } = props.computed;

  const renderResponsiveWidget = profileLayout === ProfileLayout.FullWidth;

  if (renderResponsiveWidget) {
    return (
      <DesktopResponsiveWidget
        {...props}
        fallback={
          shouldUsePlaceholderLoaders ? (
            <PlaceholderLoader sectionHeight={RESPONSIVE_WIDGET_HEIGHT} />
          ) : undefined
        }
      />
    );
  }

  return (
    <DesktopNonResponsiveWidget
      {...props}
      fallback={
        shouldUsePlaceholderLoaders ? (
          <PlaceholderLoader sectionHeight={NON_RESPONSIVE_WIDGET_HEIGHT} />
        ) : undefined
      }
    />
  );
};

export default DesktopWidget;
